import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconPptSizeM from './FileIconPpt_size_m';
import FileIconPptSizeS from './FileIconPpt_size_s';

export const FileIconPpt = createFileIcon({
  m: FileIconPptSizeM,
  s: FileIconPptSizeS,
  name: 'FileIconPpt',
});
